module.exports = __webpack_public_path__ + "static/media/Apple iPad Mini Gold.0b035703.png";